export default "__VITE_ASSET__0qV6jmjR__"